(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dji-spec-table"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initSpecTable(section){
      if (!section) return;
      var sidebarItems = section.querySelectorAll('.dji-spec-table__sidebar-item');
      var groups = section.querySelectorAll('.dji-spec-table__group');
      if (sidebarItems.length === 0) return;
      sidebarItems.forEach(function(item){
        item.addEventListener('click', function(e){
          e.preventDefault();
          var targetId = this.getAttribute('href').replace('#','');
          var target = document.getElementById(targetId);
          if (target) target.scrollIntoView({behavior:'smooth',block:'start'});
        });
      });
      window.addEventListener('scroll', function(){
        var scrollPos = window.scrollY + 100;
        groups.forEach(function(g, i){
          if (g.offsetTop <= scrollPos && g.offsetTop + g.offsetHeight > scrollPos) {
            sidebarItems.forEach(function(s){ s.classList.remove('is-active'); });
            if (sidebarItems[i]) sidebarItems[i].classList.add('is-active');
          }
        });
      });
    }
    document.querySelectorAll('.dji-spec-table').forEach(initSpecTable);
    document.addEventListener('shopify:section:load', function(event){
      var section = event.target.querySelector('.dji-spec-table');
      if (section) initSpecTable(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class CartCount extends HTMLElement {
    connectedCallback() { this._on = () => this.refresh(); document.addEventListener('cart:updated', this._on); }
    disconnectedCallback() { document.removeEventListener('cart:updated', this._on); }
    async refresh() { try { const c = await (await fetch('/cart.js')).json(); this.textContent = c.item_count; } catch (e) {} }
  }
  if (!customElements.get('cart-count')) customElements.define('cart-count', CartCount);

  class MegaMenu extends HTMLElement {
    connectedCallback() {
      this.cats = Array.from(this.querySelectorAll('[data-mega-cat]'));
      this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
      this.cats.forEach((c) => {
        const show = () => this.activate(c.getAttribute('data-mega-cat'));
        c.addEventListener('mouseenter', show);
        c.addEventListener('focus', show);
      });
    }
    activate(idx) {
      this.cats.forEach((c) => c.classList.toggle('is-active', c.getAttribute('data-mega-cat') === idx));
      this.panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === idx));
    }
  }
  if (!customElements.get('mega-menu')) customElements.define('mega-menu', MegaMenu);

  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const burger = header.querySelector('[data-burger]');
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-overlay]');
    const closeBtn = drawer && drawer.querySelector('[data-drawer-close]');
    const toggle = (open) => {
      const willOpen = open ?? drawer.hasAttribute('hidden');
      [drawer, overlay].forEach(el => { if (!el) return; if (willOpen) { el.removeAttribute('hidden'); requestAnimationFrame(() => el.classList.add('is-open')); } else { el.classList.remove('is-open'); setTimeout(() => el.setAttribute('hidden', ''), 300); } });
      burger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) { window.MetryScrollLock.lock(); } else { window.MetryScrollLock.unlock(); }
    };
    if (burger && drawer) {
      burger.addEventListener('click', () => toggle());
      if (closeBtn) closeBtn.addEventListener('click', () => toggle(false));
      if (overlay) overlay.addEventListener('click', () => toggle(false));
      drawer.addEventListener('click', e => { if (e.target.tagName === 'A') toggle(false); });
      addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) toggle(false); });
    }
  })();

  /* Mobile drawer accordion: only one first-level <details.header__acc> stays open at a time.
     Scoped to the drawer list so mega/cart <details> elsewhere are untouched. The toggle event
     does not bubble, so listen in the capture phase and filter by target. */
  (function () {
    const drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    const list = drawer.querySelector('.header__drawer-list');
    if (!list) return;
    list.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('header__acc') || !d.open) return;
      list.querySelectorAll('details.header__acc[open]').forEach((other) => { if (other !== d) other.open = false; });
    }, true);
  })();

  /* Sticky header: toggle .is-scrolled to reveal the elevation shadow once scrolled. */
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    let ticking = false;
    const update = () => { header.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; };
    update();
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  })();

  /* The campaign banner is injected as a separate sticky custom element before
     the Header Group. Keep this header below its actual rendered height rather
     than competing for top: 0 with a higher z-index. */
  (function () {
    const header = document.querySelector('[data-header]');
    const headerGroup = header && header.closest('.shopify-section-group-header-group');
    if (!headerGroup) return;

    headerGroup.__djiStickyOffsetController?.destroy();

    const abortController = new AbortController();
    let banner = null;
    let resizeObserver = null;

    const syncOffset = () => {
      if (!banner) {
        headerGroup.style.setProperty('--dji-header-sticky-top', '0px');
        return;
      }

      const style = getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      const isPinned = (style.position === 'fixed' || style.position === 'sticky')
        && style.display !== 'none'
        && style.visibility !== 'hidden'
        && rect.height > 0
        && rect.bottom > 0;

      headerGroup.style.setProperty('--dji-header-sticky-top', isPinned ? `${Math.ceil(rect.height)}px` : '0px');
    };

    const observeBanner = () => {
      const nextBanner = document.querySelector('single-banner');
      if (nextBanner === banner) {
        syncOffset();
        return;
      }

      resizeObserver?.disconnect();
      banner = nextBanner;
      if (banner && 'ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(syncOffset);
        resizeObserver.observe(banner);
      }
      syncOffset();
    };

    const bodyObserver = new MutationObserver(observeBanner);
    bodyObserver.observe(document.body, { childList: true });
    window.addEventListener('resize', syncOffset, { passive: true, signal: abortController.signal });
    document.addEventListener('shopify:section:load', observeBanner, { signal: abortController.signal });

    const destroy = () => {
      abortController.abort();
      bodyObserver.disconnect();
      resizeObserver?.disconnect();
      headerGroup.style.removeProperty('--dji-header-sticky-top');
      delete headerGroup.__djiStickyOffsetController;
    };

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === headerGroup || event.target.contains(header)) destroy();
    }, { signal: abortController.signal });

    headerGroup.__djiStickyOffsetController = { destroy };
    observeBanner();
  })();

  /* Mega dropdown hover-intent: keep the panel open for a short delay after the pointer leaves the
     top-level item, so crossing the gap into the panel doesn't momentarily drop :hover and hide it.
     Drives the panel via inline styles (highest priority) so it works regardless of :hover state. */
  (function () {
    const CLOSE_DELAY = 220;
    document.querySelectorAll('.header__nav-item.has-mega').forEach((li) => {
      const mega = li.querySelector('.header__mega');
      if (!mega) return;
      let timer = null;
      const show = () => {
        if (timer) { clearTimeout(timer); timer = null; }
        li.classList.add('is-open');
        // !important so it wins even over any global rule that force-hides panels on this page.
        mega.style.setProperty('opacity', '1', 'important');
        mega.style.setProperty('visibility', 'visible', 'important');
        mega.style.setProperty('transform', 'none', 'important');
        mega.style.setProperty('pointer-events', 'auto', 'important');
      };
      const hide = () => {
        li.classList.remove('is-open');
        mega.style.removeProperty('opacity');
        mega.style.removeProperty('visibility');
        mega.style.removeProperty('transform');
        mega.style.removeProperty('pointer-events');
      };
      const close = () => { if (timer) clearTimeout(timer); timer = setTimeout(hide, CLOSE_DELAY); };
      li.addEventListener('mouseenter', show);
      li.addEventListener('mouseleave', close);
      li.addEventListener('focusin', show);
      li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-products-display"] && !Shopify.designMode) return;
  try {
    
  class OfferCopyToClipboard extends HTMLButtonElement {
    constructor() {
      super();
      this.copyId = this.dataset.id; // Get the `data-id` attribute value
      this.copiedText = this.dataset.copied || 'Copied!'; // Text to show when copied
      this.init();
    }

    init() {
      this.addEventListener('click', this.handleCopy.bind(this));
    }

    async handleCopy() {
      if (!this.copyId) {
        console.error('No data-id found to copy!');
        return;
      }

      try {
        // Attempt to use the Clipboard API
        await navigator.clipboard.writeText(this.copyId);
        this.showCopiedMessage();
      } catch (error) {
        // Fallback to execCommand if Clipboard API fails
        console.warn('Clipboard API failed, falling back to execCommand:', error);
        this.fallbackCopy();
      }
    }

    fallbackCopy() {
      const tempInput = document.createElement('input');
      tempInput.value = this.copyId;
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);

      tempInput.select();
      document.execCommand('copy'); // Deprecated but used as a fallback
      document.body.removeChild(tempInput);

      this.showCopiedMessage();
    }

    showCopiedMessage() {
      const copiedMessage = document.createElement('div');
      copiedMessage.textContent = this.copiedText;
      copiedMessage.className = 'offer-copied-message';
      copiedMessage.style.opacity = '0';

      this.closest('[data-clipboard-wrapper]')?.appendChild(copiedMessage);

      setTimeout(() => {
        copiedMessage.style.opacity = '1';
      }, 0);

      setTimeout(() => {
        copiedMessage.style.opacity = '0';
        copiedMessage.remove();
      }, 2000);
    }
  }
  customElements.define('offer-copy-to-clipboard', OfferCopyToClipboard, { extends: 'button' });

  } catch(e) { console.error(e); }
})();
})();
